<template>
  <div class="v3-widget v3-panel" v-testid="testid">
    <div class="v3-panel-head">
      <h3 v-testid="testid + '-title'">{{ title }}</h3>
      <span v-if="rd.count.value" class="sub">{{ rd.count.value }} documents</span>
    </div>

    <V3Skeleton v-if="rd.isLoading.value && !rd.count.value" shape="list" :heading="false" />
    <div v-else-if="!rd.count.value" class="v3-task-empty" v-testid="testid + '-empty'">No documents.</div>

    <div v-else class="v3-dtable" role="table">
      <div class="v3-dtable-h" role="row" aria-hidden="true">
        <span>Reference</span><span>Type</span><span>Owner</span><span>Quality</span><span>Status</span><span class="v3-cell--right">Updated</span>
      </div>
      <div
        v-for="r in rd.shownRows.value"
        :key="r.doc_id"
        class="v3-dtable-r"
        role="row"
        tabindex="0"
        v-testid="testid + '-row-' + r.doc_id"
        @click="open(r)"
      >
        <span>
          <span class="v3-row-title">{{ rd.title(r) }}</span>
          <span class="v3-row-sub">{{ rd.reference(r) }}</span>
        </span>
        <span class="v3-cell">{{ rd.docType(r) }}</span>
        <span><span v-if="rd.owner(r)" class="v3-avatar" :title="rd.owner(r)">{{ rd.initials(rd.owner(r)) }}</span></span>
        <span>
          <span v-if="rd.hasScore(r)" class="v3-jscore" :class="'v3-jscore--' + rd.scoreTone(r)" :title="'Quality ' + rd.scoreVal(r)">
            <span class="v3-jscore-bar"><span :style="{ width: rd.scorePct(r) + '%' }"></span></span>
            <span class="v3-jscore-n">{{ rd.scoreVal(r) }}</span>
          </span>
        </span>
        <span>
          <span v-if="rd.statusLabel(r)" class="v3-spill" :style="{ color: rd.statusColour(r) }"><span class="dot"></span>{{ rd.statusLabel(r) }}</span>
        </span>
        <span class="v3-cell v3-cell--right">{{ rd.whenText(r) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { recentDocs } from "@rm-ui/homepage/recentDocs";
import V3Skeleton from "./cLandingV3Skeleton";

// New-portal (v3) DocListFull — the faceted documents table (prototype
// V3DocListFull): Reference · Type · Owner · Quality (linear V3ScoreMeter bar)
// · Status · Updated. Shares the `recentDocs` composable + Report/recentDocs
// endpoint with the compact DocList. Sibling: rm-portal-beta DocListFullWidget.vue.
export default {
  name: "cLandingV3DocListFull",
  components: { V3Skeleton },
  props: {
    definition: { type: Object, default: () => ({}) },
    editMode: { type: Boolean, default: false },
    qaActions: { type: Array, default: () => [] },
  },
  setup(props) {
    const rd = recentDocs({
      http: axios,
      getLimit: () => props.definition.limit || 12,
      getDocTypes: () => props.definition.docTypes || [],
      getStatuses: () => props.definition.statuses || [],
    });
    return { rd };
  },
  computed: {
    testid() {
      return this.definition.controlType || "v3DocListFull";
    },
    title() {
      return this.definition.title || "Job profiles";
    },
  },
  methods: {
    open(r) {
      if (this.editMode) return;
      const reference = r.reference || r.system_number;
      if (reference) this.$emit("openDocument", { system_number: reference, reference });
    },
  },
};
</script>

<style lang="scss" src="./v3Widgets.scss"></style>
